import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import Activities from "@/pages/Activities";
import CalendarPage from "@/pages/CalendarPage";
import Reports from "@/pages/Reports";
import WhatsAppPage from "@/pages/WhatsApp";
import Team from "@/pages/Team";
import UserPerformance from "@/pages/UserPerformance";
import Automations from "@/pages/Automations";
import Settings from "@/pages/Settings";
import Account from "@/pages/Account";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/account" element={<Account />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/leads/:id" element={<LeadDetail />} />
              <Route path="/attivita" element={<Activities />} />
              <Route path="/calendario" element={<CalendarPage />} />
              <Route path="/report" element={<Reports />} />
              <Route path="/whatsapp" element={<WhatsAppPage />} />
              <Route path="/performance/:userId" element={<UserPerformance />} />
              <Route
                path="/team"
                element={<ProtectedRoute adminOnly><Team /></ProtectedRoute>}
              />
              <Route
                path="/automazioni"
                element={<ProtectedRoute adminOnly><Automations /></ProtectedRoute>}
              />
              <Route
                path="/impostazioni"
                element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>}
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
